import React from "react";

import { I1Column } from "../../../interfaces";
import { applyTransformations } from "../../../utils";
import CmsMarkdown from "../../basic/cms-markdown";
import CmsHtml from "../../basic/cms-html";
import CmsLink from "../../links/cms-link";
import classNames from "classnames";
import SVG from "../../svg";
import { COMPONENTS } from "../../../constants";

const Col1 = ({
  background_color,
  background_image,
  has_background_cutout,
  button,
  content,
  id,
  css_override
}: I1Column) => {
  const cssOverrides = css_override?.add_classes;

  const classes = classNames("cms-col-1", `cms-col-1-${id}`, cssOverrides, {
    section_background_cutout: has_background_cutout
  });

  const backgroundImage = background_image?.data?.attributes;

  const getBackgroundImage = () => {
    if (backgroundImage == null) return {};
    const { url } = backgroundImage;

    return {
      backgroundImage: `url(${applyTransformations(url, { w: 1700 })})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    };
  };

  return (
    <>
      {has_background_cutout && (
        <div style={{ height: "0px" }}>
          <SVG name="section-cutout" />
        </div>
      )}
      <div className={classes} style={getBackgroundImage()}>
        {background_color && (
          <div
            style={{ backgroundColor: background_color }}
            className={classNames("color-overlay", {
              "has-background-image": backgroundImage
            })}
          />
        )}
        <div className={`container-wrapper container-r-narrow mx-auto`}>
          <div className="container-lg d-flex flex-column py-7 p-responsive">
            {content && content.__typename === COMPONENTS.HTML && (
              <CmsHtml {...content} html={content.text} />
            )}
            {content && content.__typename !== COMPONENTS.HTML && <CmsMarkdown content={content} />}
            <CmsLink link={button} classnames={["btn", "text-center", "mx-auto", "f3", "p-3"]} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Col1;
